import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useProductDispatch, useProductStore } from '../ProductProvider';
import NavProduct from '../tabs/NavProduct';
// import NavProduct from '../comps/NavProduct';

import TabBundles from '../tabs/TabBundles';
import TabMedia from '../tabs/TabMedia';
import TabSpecs from '../tabs/TabSpecs';
import TabSupport from '../tabs/TabSupport';
import styles from './index.module.scss';
import ProductContent from './ProductContent';
import NewProductContent from './NewProductContent';

const theme = 'white';
const tabList = ['Product', 'Support', 'Specs'];
export default function Detail() {
    const { productTabActive } = useProductStore();
    const dispatch = useProductDispatch();
    const router = useRouter();
    const { locale = 'us', query } = router;
    const tabName: string = (query.tab as string) || '';
    const IS_NA_SITES = ['us', 'ca', 'br', 'mx'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'kr', 'ph', 'nl'].includes(locale);

    useEffect(() => {
        if (tabName && tabList.includes(tabName)) {
            dispatch({
                type: 'changeProductTabActive',
                payload: tabName,
            });
        }
    }, [tabName]);

    return (
        <div className={styles.detail}>
            <NavProduct />
            <div className={`product-item-tab${productTabActive === 'Product' ? ' product-item-tab-active' : ''}`}>
                {IS_NA_SITES || IS_EU_SITES ? <NewProductContent /> : <ProductContent />}
            </div>
            {productTabActive === 'Bundles' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabBundles />
                </div>
            )}
            {productTabActive === 'Support' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSupport theme={theme} />
                </div>
            )}
            {productTabActive === 'Specs' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSpecs theme={theme} />
                </div>
            )}
            <div className={`product-item-tab${productTabActive === 'Media' ? ' product-item-tab-active' : ''}`}>
                <TabMedia />
            </div>
        </div>
    );
}
